import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { createBrowserHistory } from "history";
import configureStore from "./Redux/ConfigureStore";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";

//Styles
import "./Theme/bootstrap.css";
import "./Theme/FontAwesome/CSS/font-awesome.min.css";
import "./Theme/Global.scss";

declare global {
  interface Window {
    initialReduxState: Object;
    analytics: any;
    hostEndpoint: any;
  }
}

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const history = createBrowserHistory({ basename: baseUrl as string });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const { store, persistor } = configureStore(history, initialState);

// Allow useSelector by specifying the root state type
export type RootState = ReturnType<typeof store.getState>
const rootElement = document.getElementById("b2b-root");

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </PersistGate>
  </Provider>,
  rootElement
);
